import { SmtpConfigI, ValidationSet } from '../../../../types/interface';
import { commonValidations } from '../validations';

export const SmtpConfigValidationSet: ValidationSet<SmtpConfigI> = {
  host: commonValidations.host,
  pass: commonValidations.pass,
  port: commonValidations.port,
  user: commonValidations.user,
  secure: [],
  to: commonValidations.to,
  from: commonValidations.from
};
